import React, { Component } from 'react'
import { observer } from 'mobx-react'
import withStyles from 'react-jss'
import classNames from 'classnames'

import { LESSON_STATUSES_PUBLISH_STATES } from 'constants/courses.constants'
import { COURSE_LESSONS_NAV_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'

import CustomButton from '../custom-button/CustomButton'
import lessonsNavigationStyles from './lessonsNavigationStyles'

@observer
class LessonsNavigation extends Component {
  render() {
    const {
      classes,
      courseRefreshAppActive,
      toggleConfirmationModal,
      courseViewsStore: {
        activeLesson: { allowLessonReset, lessonSettings = {} },
        activeLessonStatus = {},
        product: { allowCourseReset },
        isOverviewPage,
        setPrevLesson,
        setNextLesson,
        finishLesson,
        viewConfig: { showPrevBtn, showNextBtn, showFinishBtn, lessonIsFinished, shouldCompleteQuiz },
      },
      contentPageStore: { allVideoCodesValid },
      noPaddings,
      desktopResolution,
    } = this.props
    const isNavigationButtonDisabled = shouldCompleteQuiz && lessonIsFinished
    const resetCourseButtonAvailable = allowCourseReset && isOverviewPage
    const resetLessonButtonAvailable =
      allowLessonReset && activeLessonStatus.publishState === LESSON_STATUSES_PUBLISH_STATES.finished
    const resetButtonAvailable = courseRefreshAppActive && (resetCourseButtonAvailable || resetLessonButtonAvailable)
    const lessonsNavigationClasses = classNames(
      COURSE_LESSONS_NAV_CLASS_NAMES.containerClassName,
      classes.lessonsNavigation,
      noPaddings && classes.noPaddings
    )

    return (
      <div className={lessonsNavigationClasses}>
        {desktopResolution && (
          <CustomButton onClick={setPrevLesson} hidden={!showPrevBtn} disabled={isNavigationButtonDisabled}>
            <i className='fas fa-chevron-left' />
            <span>{I18n.t('react.shared.lessons.prevLesson')}</span>
          </CustomButton>
        )}

        <CustomButton
          onClick={finishLesson}
          hidden={!showFinishBtn}
          disabled={!allVideoCodesValid}
          outline
          className={classes.finishButton}
        >
          {!desktopResolution && <i className='fas fa-flag-checkered' />}
          <span>{lessonSettings.finishButtonText || I18n.t('react.shared.lesson.finishLesson')}</span>
        </CustomButton>
        <div className={classNames(COURSE_LESSONS_NAV_CLASS_NAMES.btnContainerClassName, classes.buttonContainer)}>
          {resetButtonAvailable && (
            <CustomButton outline onClick={toggleConfirmationModal} className={classes.finishButton}>
              <i className='fas fa-undo-alt' />
              {isOverviewPage ? I18n.t('react.shared.button.reset_course') : I18n.t('react.shared.button.reset_lesson')}
            </CustomButton>
          )}
          {desktopResolution && (
            <CustomButton onClick={setNextLesson} hidden={!showNextBtn} disabled={isNavigationButtonDisabled}>
              <span>{I18n.t('react.shared.lessons.nextLesson')}</span>
              <i className='fas fa-chevron-right' />
            </CustomButton>
          )}
        </div>
      </div>
    )
  }
}

export default withStyles(lessonsNavigationStyles)(LessonsNavigation)
